<agr-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column spacing--margin-top">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'invoice-date' | translate }}</mat-label>
      <input
        matInput
        formControlName="invoiceDate"
        [matDatepicker]="invoiceDatePicker"
        placeholder="{{ 'invoice-date' | translate }}"
        data-test="final-setup-edit-item__invoice-date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="invoiceDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #invoiceDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'invoice-number' | translate }}</mat-label>
      <input
        matInput
        formControlName="invoiceNumber"
        placeholder="{{ 'invoice-number' | translate }}"
        data-test="final-setup-edit-item__invoice-number"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'amount-excluding-vat' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="amount"
        placeholder="{{ 'amount-excluding-vat' | translate }}"
        data-test="final-setup-edit-item__amount"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'vat-percentage' | translate }}</mat-label>
      <span matTextSuffix class="form-field-suffix">%</span>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="vatPercentage"
        data-test="final-setup-edit-item__vatPercentage"
      >
        <mat-option [value]="null"></mat-option>
        <mat-option *ngFor="let vatPercentage of vatPercentages" [value]="vatPercentage">
          {{ vatPercentage }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</agr-dialog>
